import { Field, Flex } from '@optiaxiom/react';

import type {
  AgentParameter,
  AgentParameterType,
  AgentParameterValue,
} from '@frontend/types/specialized-agent';

import { ParameterInputRenderer } from './ParameterInputRenderer';

type ParameterFormProps = {
  parameters: Array<AgentParameter<AgentParameterType>>;
  values: Record<string, AgentParameterValue<AgentParameterType>>;
  onChange: (paramName: string, value: AgentParameterValue<AgentParameterType>) => void;
  onFileUpload?: (paramName: string, file: File) => Promise<void>;
  uploadingParams?: string[];
};

export function ParameterForm({
  parameters,
  values,
  onChange,
  onFileUpload,
  uploadingParams = [],
}: ParameterFormProps) {
  if (parameters.length === 0) {
    return null;
  }

  const handleFileUpload = async (paramName: string, file: File) => {
    if (onFileUpload) {
      await onFileUpload(paramName, file);
    }
  };

  return (
    <Flex flexDirection="column" gap="16" w="full">
      {parameters.map(parameter => (
        <Field key={parameter.name} label={parameter.name} required={parameter.required}>
          <ParameterInputRenderer
            parameter={parameter}
            value={values[parameter.name]}
            onChange={value => onChange(parameter.name, value)}
            onFileUpload={file => handleFileUpload(parameter.name, file)}
            isUploading={uploadingParams.includes(parameter.name)}
          />
        </Field>
      ))}
    </Flex>
  );
}
